import { PackageCardData } from "../package-card/package-card-data";

export class AddonGroup {
  public GroupID: number;
  public GroupName: string;
  public GroupDbName: string;
  public GroupDescription: string;
  public Addons: PackageCardData[];
}
